import dynamic from 'next/dynamic'

export const DynamicCounter = dynamic(() => import('@/shared/ui/Counter/Counter').then(({ Counter }) => Counter), {
	ssr: false,
	loading: () => null // Не показываем загрузку, так как это маленький компонент
})

// Альтернативный вариант с кастомным загрузчиком
export const DynamicCounterWithLoader = dynamic(
	() => import('@/shared/ui/Counter/Counter').then(({ Counter }) => Counter),
	{
		ssr: false,
		loading: () => <div style={{ width: '1.6rem', height: '1.6rem' }} />
	}
)
